export class User {
  nameid: string;
  unique_name: string;
  role: string;
  email: string;
  given_name: string;
  nbf: number;
  exp: number;
  passwordReset: boolean; 

  constructor(
    nameid: string = '',
    unique_name: string = '',
    role: string = '',
    email: string = '',
    given_name: string = '',
    nbf: number = 0,
    exp: number = 0,
    passwordReset: boolean = true 
  ) {
    this.nameid = nameid;
    this.unique_name = unique_name;
    this.role = role;
    this.email = email;
    this.given_name = given_name;
    this.nbf = nbf;
    this.exp = exp;
    this.passwordReset = passwordReset;
  }

  static fromJson(json: any): User {
    return new User(
      json.nameid,
      json.unique_name,
      json.role,
      json.email,
      json.given_name,
      json.nbf,
      json.exp,
      json.passwordReset ?? true 
    );
  }
}
